module.exports = __webpack_public_path__ + "img/img3.99d473d8.png";